$ = jQuery;

(function ($) {
    $.fn.bindWithDelay = function (type, data, fn, timeout, throttle) {
        if ($.isFunction(data)) {
            throttle = timeout;
            timeout = fn;
            fn = data;
            data = undefined;
        }

        // Allow delayed function to be removed with fn in unbind function
        fn.guid = fn.guid || ($.guid && $.guid++);

        // Bind each separately so that each element has its own delay
        return this.each(function () {
            var wait = null;

            function cb() {
                var e = $.extend(true, {}, arguments[0]);
                var ctx = this;
                var throttler = function () {
                    wait = null;
                    fn.apply(ctx, [e]);
                };

                if (!throttle) {
                    clearTimeout(wait);
                    wait = null;
                }
                if (!wait) {
                    wait = setTimeout(throttler, timeout);
                }
            }

            cb.guid = fn.guid;

            $(this).bind(type, data, cb);
        });
    };
})(jQuery);

$(function () {
    $("#search-participant").bindWithDelay("keyup", function () {
        const searchValue = $(this).val();
        if (searchValue.length >= 3) {
            getParticipants(searchValue);
        } else if (searchValue.length == 0) {
            getParticipants(null);
        }
    });

    function getParticipants(search) {
        let data = {
            action: "ajax_get_users_lpl",
        };
        if (search) {
            data.search = search;
        }
        $(".participants-result").html(
            "<div class='fishy-content'><div class='background'></div></div>"
        );
        $.ajax({
            type: "POST",
            dataType: "html",
            url: ajaxurl,
            data: data,

            success: function success(data) {
                console.log(search);
                console.log(data);
                $(".participants-result").html(data);
            },
            error: function error(jqXHR, textStatus, errorThrown) {
                console.log(jqXHR + " :: " + textStatus + " :: " + errorThrown);
            },
        });
    }
});
